import * as BookmarkTypes from 'common/types/reports/bookmark';

const DEFAULT_RETENTION_CLAUSE: BookmarkTypes.BehaviorShowClause = {
  type: BookmarkTypes.TopLevelMetricType.Metric,
  behavior: {
    type: BookmarkTypes.MetricType.Retention,
    name: null,
    retentionType: `birth`,
    retentionAlignmentType: BookmarkTypes.RetentionAlignmentType.Birth,
    retentionUnit: BookmarkTypes.BaseTimeUnit.Day,
    retentionUnboundedMode: `none`,
    retentionCustomBucketSizes: [],
    resourceType: BookmarkTypes.InsightsResourceType.Events,
    behaviors: [
      {
        type: BookmarkTypes.MetricType.Event,
        name: null,
        filters: [],
        filtersDeterminer: `all`,
      },
      {
        type: BookmarkTypes.MetricType.Event,
        name: null,
        filters: [],
        filtersDeterminer: `all`,
      },
    ],
  },
  measurement: {
    math: BookmarkTypes.RETENTION_MATH_TYPES.RETENTION_RATE,
    retentionBucketIndex: 0,
  },
};

const DEFAULT_RETENTION_FREQUENCY: BookmarkTypes.BehaviorShowClause = {
  type: BookmarkTypes.TopLevelMetricType.Metric,
  behavior: {
    type: BookmarkTypes.MetricType.RetentionFrequency,
    name: null,
    retentionType: `addiction`,
    retentionAlignmentType: BookmarkTypes.RetentionAlignmentType.Birth,
    retentionUnit: BookmarkTypes.BaseTimeUnit.Day,
    retentionUnboundedMode: `none`,
    retentionCustomBucketSizes: [],
    resourceType: BookmarkTypes.InsightsResourceType.Events,
    behaviors: [
      {
        type: BookmarkTypes.MetricType.Event,
        name: null,
        filters: [],
      },
    ],
  },
  measurement: {
    math: BookmarkTypes.RETENTION_MATH_TYPES.RETENTION_RATE,
    retentionBucketIndex: 0,
  },
};

const DEFAULT_FUNNEL_CLAUSE: BookmarkTypes.BehaviorShowClause = {
  type: BookmarkTypes.TopLevelMetricType.Metric,
  behavior: {
    type: BookmarkTypes.MetricType.Funnel,
    name: null,
    conversionWindowDuration: 7,
    conversionWindowUnit: BookmarkTypes.ConversionWindowUnit.Day,
    funnelOrder: BookmarkTypes.FunnelOrder.Loose,
    aggregateBy: [],
    resourceType: BookmarkTypes.InsightsResourceType.Events,
    behaviors: [
      {
        type: BookmarkTypes.MetricType.Event,
        name: null,
        filters: [],
      },
      {
        type: BookmarkTypes.MetricType.Event,
        name: null,
        filters: [],
      },
    ],
  },
  measurement: {
    math: BookmarkTypes.FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE,
    stepIndex: null,
  },
};

const DEFAULT_SIMPLE_CLAUSE: BookmarkTypes.BehaviorShowClause = {
  type: BookmarkTypes.TopLevelMetricType.Metric,
  behavior: {
    type: BookmarkTypes.MetricType.Simple,
    name: null,
    resourceType: BookmarkTypes.InsightsResourceType.Events,
    behaviors: [
      {
        type: BookmarkTypes.MetricType.Event,
        name: null,
        filters: [],
      },
    ],
  },
  measurement: {
    math: BookmarkTypes.PRIMITIVE_MATH_TYPES.UNIQUE,
  },
};

export const DEFAULT_CLAUSE_BY_TYPE: Partial<Record<BookmarkTypes.MetricType, BookmarkTypes.BehaviorShowClause>> = {
  [BookmarkTypes.MetricType.Simple]: DEFAULT_SIMPLE_CLAUSE,
  [BookmarkTypes.MetricType.Funnel]: DEFAULT_FUNNEL_CLAUSE,
  [BookmarkTypes.MetricType.Retention]: DEFAULT_RETENTION_CLAUSE,
  [BookmarkTypes.MetricType.RetentionFrequency]: DEFAULT_RETENTION_FREQUENCY,
};
